export default __webpack_public_path__ + "static/bettyblocks-7d4e51bf0228b4fcef9549b2172dc381.svg";